<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">German Girls</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#part-1-august-1978-swanage-dorset">Part 1 August 1978 Swanage,
          Dorset</a>
<ol class="toc">
<li id="toc-li-4"><a href="#/text/ch003#saturday">Saturday</a></li>
<li id="toc-li-5"><a href="#/text/Section0001#sunday">Sunday</a></li>
<li id="toc-li-6"><a href="#/text/Section0001#monday">Monday</a></li>
<li id="toc-li-7"><a href="#/text/Section0001#tuesday">Tuesday</a></li>
<li id="toc-li-8"><a href="#/text/Section0001#wednesday">Wednesday</a></li>
<li id="toc-li-9"><a href="#/text/Section0001#thursday">Thursday</a></li>
<li id="toc-li-10"><a href="#/text/Section0001#friday">Friday</a></li>
<li id="toc-li-11"><a href="#/text/Section0001#saturday-home-sunbury--on-thames">Saturday – Home –
              Sunbury- on-Thames</a></li>
<li id="toc-li-12"><a href="#/text/Section0001#monday-back-at-work">Monday – Back at Work</a></li>
<li id="toc-li-13"><a href="#/text/Section0001#saturday-the-grafton-hotel-swanage">Saturday – The Grafton
              Hotel – Swanage</a></li>
<li id="toc-li-14"><a href="#/text/Section0001#sunday-the-grafton-hotel">Sunday – The Grafton Hotel</a>
</li>
</ol>
</li>
<li id="toc-li-15"><span href="#/text/ch004#part-2-september-1978-frankfurt-germany" title="Link target outside of Sample">Part 2 September 1978
          Frankfurt, Germany</span>
<ol class="toc">
<li id="toc-li-16"><span href="#/text/ch004#the-boy-fun-flirt-club" title="Link target outside of Sample">The Boy Fun Flirt Club</span></li>
<li id="toc-li-17"><span href="#/text/Section0002#thursday-26th-october" title="Link target outside of Sample">Thursday, 26<sup>th</sup>
              October</span></li>
<li id="toc-li-18"><span href="#/text/Section0002#frankfurt-germany" title="Link target outside of Sample">Frankfurt, Germany</span></li>
<li id="toc-li-19"><span href="#/text/Section0002#friday-27th-october" title="Link target outside of Sample">Friday, 27<sup>th</sup> October</span>
</li>
<li id="toc-li-20"><span href="#/text/Section0002#heathrow-airport-england" title="Link target outside of Sample">Heathrow Airport, England</span>
</li>
</ol>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?30d82c3a